import { API_DOMAIN } from '@constants/app-constants';
import { call, put, takeEvery } from 'redux-saga/effects';
import Actions from '../action';
import Axios from 'axios';
import { message } from 'antd';


export function* getCompanyInfoCongratServiceWorker(action) {
	try {
		// let companyId = CAMPANY.Id;
		let companyId = localStorage.getItem('companyId');
		console.log('COMP ::', companyId);
		const uri = `${API_DOMAIN}/Company/` + companyId;
		let res = yield call(Axios.get, uri);
		console.log('resssss', res);
		yield put(Actions.creators.getCompanyInfoCongratulatSuccess(res.data.company));
	} catch (err) {
		// message.error(err);
		yield put(Actions.creators.getCompanyInfoCongratulatError());
	}
}

export function* getTempletServiceWorker(action) {
	try {
		const uri = `${API_DOMAIN}/FileTemplate/Employee/Download`;
		let res = yield call(Axios.get, uri);
		console.log('RESS ::', res);
		yield put(Actions.creators.getEmployeeTempletSuccess(res));
	} catch (err) {
		// message.error(err);
		yield put(Actions.creators.getEmployeeTempletError());
	}
}

export default function* congratulationWatcher() {
	yield takeEvery(Actions.types.GET_COMPANY_INFO_CONGRATS_START, getCompanyInfoCongratServiceWorker);
	yield takeEvery(Actions.types.GET_EMPLOYEE_TEMPLET_START, getTempletServiceWorker);
}
